module.exports = __webpack_public_path__ + "static/media/ic_pa_b7_fisdom.6166209a.svg";